<template>
  <div class="averta-bold is-flex">
    <div
      :style="{
        minWidth: `${minWidthSideColumn}px`,
        width: `${widthColumnNavProps + 6}px`,
        height: heightColumn
      }"
      class="nav-col nav-col-side border-right-5 border-left-1 sticky-all z-index-5 bg-grey-8 is-justify-content-flex-start is-flex-direction-column"
      :class="{ 'shrink-side': isShrink }"
    >
      <div class="flex-center-vertical c-w-100 px-3" :class="[isShrink ? 'flex-2' : 'flex-1-3']">
        <p class="averta-bold" :class="{ 'label-18': isShrink }">Tahap</p>
      </div>
      <div
        class="flex-1 border-top-1 c-w-100 px-3"
        :class="
          dateSummary && !isTodaySummary
            ? 'is-flex-direction-column is-align-items-flex-start flex-center-horizontal'
            : 'flex-center-vertical'
        "
      >
        <p class="averta-bold" :class="{ 'label-18': isShrink }">Ringkasan</p>
        <div
          v-if="isTodaySummary"
          class="bg-light-blue-2 color-blue-1 white-space-nowrap px-2 py-1 border-radius-100 ml-1 label-12"
          :class="{ 'label-14': isShrink }"
        >
          Hari ini
        </div>
        <div v-else-if="dateSummary">
          <p class="white-space-nowrap">{{ dateSummary }}</p>
        </div>
      </div>
    </div>
    <div
      class="nav-table"
      :class="{
        'nav-table-shrink': isShrink
      }"
    >
      <div
        v-for="(item, index) in dataNavbar"
        :key="`nav-${index}`"
        :ref="`navbar-table-progress-${index}`"
        :style="{
          width: `${widthColumnProps}px`,
          height: heightColumn
        }"
        :class="{
          'border-radius-top-right-10 border-right-2': index + 1 === dataNavbar.length,
          'border-right-5': index === 1,
          'bg-light-blue-1': idxSelectedStatus && idxSelectedStatus === index,
          'shrink-status': isShrink
        }"
        class="nav-col bg-grey-8 overflow-visible"
      >
        <div class="c-w-100 c-h-100 flex-center is-flex-direction-column">
          <div class="flex-center" :class="[isShrink ? 'flex-2' : 'flex-1-3']">
            <b-tooltip
              position="is-bottom"
              type="is-dark"
              :triggers="['hover']"
              :auto-close="true"
              :class="{ 'c-h-100': isShrink }"
            >
              <template v-slot:content>
                <div :style="{ zoom: `${1 / scaleTable}` }" class="p-1">
                  <p class="averta-bold has-text-left py-2">{{ item.title }}</p>
                  <p
                    v-if="item.tooltipDesc"
                    class="averta-regular has-text-left tooltip-desc"
                    :class="{ 'w-additional-desc': item.additionalDesc }"
                  >
                    {{ item.tooltipDesc }}
                  </p>

                  <div v-if="item.additionalDesc" class="additional-desc p-1 my-1">
                    <p class="color-black label-12 averta-regular">{{ item.additionalDesc }}</p>
                  </div>
                </div>
              </template>
              <div
                class="is-flex is-align-items-center px-1"
                :class="[
                  {
                    'is-flex-direction-column is-justify-content-space-between py-2 c-h-100':
                      isShrink
                  }
                ]"
              >
                <p
                  class="mr-2 title-navbar text-ellipsis-2"
                  :class="{ 'mb-1 label-18 adjust-title': isShrink }"
                >
                  {{ item.title }}
                </p>
                <div
                  class="flex-shrink-0 is-flex is-align-items-flex-end"
                  :class="{ 'info-icon-progress': isShrink }"
                >
                  <InfoIcon v-if="item.tooltipDesc" color="#3185FC" width="18" height="18" />
                </div>
              </div>
            </b-tooltip>
          </div>
          <div class="border-top-1 flex-center flex-1 c-w-100">
            <p class="label-18" :class="{ 'label-22': isShrink }">
              {{ getDataSummary(item.afterTitle) }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { InfoIcon } from '@/components/icons'
import moment from 'moment'

export default {
  name: 'NavbarTableProgress',
  components: {
    InfoIcon
  },
  props: {
    widthColumnProps: {
      type: Number
    },
    widthColumnNavProps: {
      type: Number
    },
    heightColumnNavProps: {
      type: Number
    },
    scaleTableProps: {
      type: Number
    },
    dataSummary: {
      type: Object,
      default: null
    },
    dateSummary: {
      type: String,
      default: null
    },
    minWidthSideColumn: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters({
      filterDate: 'report/getSaveDateFilterProgress',
      navbar: 'report/getDataNavbarReportProgress'
    }),
    scaleTitle () {
      if (this.scaleTable < 0.69) {
        const result = this.scaleTable * this.heightColumnNavProps
        return result
      }
      return 0
    },
    heightColumn () {
      return `${this.heightColumnNavProps * 1.9 + this.scaleTitle}px`
    },
    isShrink () {
      return this.scaleTable < 0.6
    },
    isTodaySummary () {
      const startProps = this.filterDate ? this.filterDate.start : new Date()
      const endProps = this.filterDate ? this.filterDate.end : new Date()

      const start = moment(startProps)
      const end = moment(endProps)
      if (start.isSame(end, 'day')) {
        const date = moment(startProps)
        const today = moment(new Date())

        if (date.isSame(today, 'day')) {
          return true
        }
      }
      return false
    }
  },
  data () {
    return {
      idxSelectedStatus: null,
      dataNavbar: [],
      scaleTable: 1
    }
  },
  methods: {
    scrollTo (index) {
      let el = this.$refs[`navbar-table-progress-${index}`]
      if (Array.isArray(el)) {
        el = el[0]
      }
      if (el && el.scrollIntoView) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' })
      }
    },
    getDataSummary (title) {
      const result = this.dataSummary.list.find((obj) => obj.status_name === title)
      return result ? result.total : 0
    }
  },
  mounted () {
    const temp = localStorage.getItem('report_status')
    if (temp && JSON.parse(temp)) {
      this.idxSelectedStatus = JSON.parse(temp) && JSON.parse(temp).idx_column_report
    } else {
      this.idxSelectedStatus = null
    }
    this.scaleTable = this.scaleTableProps
  },
  created () {
    this.dataNavbar = this.navbar
  },
  watch: {
    scaleTableProps (val) {
      this.scaleTable = val
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';

.nav-table {
  display: flex;
  position: relative;

  &.nav-table-shrink {
    flex: 1;
    min-width: 0;
  }
}

.nav-col {
  border-right: 1px solid $color-grey-2;
  border-top: 1px solid $color-grey-2;
  border-bottom: 1px solid $color-grey-2;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  &.nav-col-side {
    border-top-left-radius: 10px;
  }

  &.shrink-side {
    flex: 0 0 7%;
  }

  &.shrink-status {
    flex: 1;
    min-width: 0;
    text-overflow: ellipsis;
  }
}

.tooltip-desc {
  display: inline-block;
  white-space: normal;
  width: 15em;
}

.title-navbar {
  max-width: 13em;
  line-height: 23px;

  &.adjust-title {
    transform: translateY(2px);
  }
}

.w-additional-desc {
  width: auto !important;
}

.additional-desc {
  background: $color-white;
  border-radius: 8px;
  width: 250px;
  white-space: normal;
  text-align: left;
}

.info-icon-progress {
  transform: translateY(-1px);
}
</style>
